const createState = () => ({
  messages: [],
  toolMessage: '',
});

export default createState;
